import axios from 'axios';
import { BASE_URL } from 'api/config';
import { LoginRequest, TokenPair } from 'api/model';

const authClient = axios.create({
  baseURL: BASE_URL,
  headers: { 'Content-Type': 'application/json' },
});

export const loginRequest = async (credentials: LoginRequest): Promise<TokenPair> => {
  const response = await authClient.post<TokenPair>('/auth/login', credentials);
  return response.data;
};

export const refreshTokenRequest = async (refreshToken: string): Promise<TokenPair> => {
  const response = await authClient.post<TokenPair>('/auth/refresh', { refresh_token: refreshToken });
  return response.data;
};

export const logoutRequest = async (refreshToken: string): Promise<void> => {
  await authClient.post('/auth/logout', { refresh_token: refreshToken });
};
